
import React, { useEffect, useState } from "react";
import {
    Box,
    Grid,
    Card,
    CardContent,
    Typography,
    Button,
    Divider,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import APIURL, { IMAGE_BASE_URL } from "../api/apiClient";
import Loader from "../components/Loader";

const OfferBannerList = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [offers, setOffers] = useState([]);

    useEffect(() => {
        const fetchOffers = async () => {
            setLoading(true);
            try {
                const data = await APIURL.get("/fetchofferbanners.php");
                if (data.success) {
                    setOffers(data.data);
                } else {
                    console.warn("No offers found");
                }
            } catch (err) {
                console.error("Error fetching offers:", err);
            } finally {
                setLoading(false);
            }
        };
        fetchOffers();
    }, []);

          // ✅ Full screen loader while fetching
      if (loading) {
        return <Loader type="full" loading={loading} />;
      }

    return (
        <>
            {/* <Loader type="full" loading={loading} /> */}

            <Box
                sx={{
                    p: 2,
                    minHeight: "100vh",
                    bgcolor: "background.default",
                    display: "flex",
                    flexDirection: "column",
                }}
            >
                {/* Header */}
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        mb: 4,
                        borderBottom: "2px solid",
                        borderColor: "divider",
                        pb: 1.5,
                    }}
                >
                    <Typography variant="h4" sx={{ fontWeight: 700 }}>
                        Offer Banners
                    </Typography>

                    <Button
                        variant="contained"
                        color="primary"
                        size="large"
                        onClick={() => navigate("/addoffers")}
                        sx={{
                            borderRadius: "8px",
                            textTransform: "none",
                            fontWeight: 600,
                            boxShadow: 3,
                        }}
                    >
                        + Add Offer
                    </Button>
                </Box>

                {/* Offer Cards */}
                <Grid container spacing={3}>
                    {offers.map((offer) => (
                        <Grid item xs={12} sm={6} md={4} key={offer.id}>
                            <Card
                                sx={{
                                    height: "100%",
                                    borderRadius: 3,
                                    boxShadow: "0 6px 20px rgba(0,0,0,0.1)",
                                    border: "1px solid #e0e0e0",
                                    transition: "transform 0.3s ease, box-shadow 0.3s ease",
                                    "&:hover": {
                                        transform: "translateY(-5px)",
                                        boxShadow: "0 10px 25px rgba(0,0,0,0.15)",
                                    },
                                }}
                            >
                                <CardContent>
                                    <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>
                                        Offer ID: {offer.id}
                                    </Typography>
                                    <Divider sx={{ mb: 2 }} />

                                    <Typography
                                        variant="body2"
                                        color="text.secondary"
                                        sx={{ mb: 0.5 }}
                                    >
                                        <strong>From:</strong> {offer.from_date}
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary">
                                        <strong>To:</strong> {offer.to_date}
                                    </Typography>

                                    {/* Images */}
                                    <Box
                                        sx={{
                                            display: "flex",
                                            flexWrap: "wrap",
                                            gap: 1,
                                            mt: 2,
                                        }}
                                    >
                                        {offer.images.map((img, index) => (
                                            <Box
                                                key={index}
                                                component="img"
                                                src={`${IMAGE_BASE_URL}${img}`} // ✅ Full URL now correct
                                                alt={`flyer-${index}`}
                                                sx={{
                                                    width: 90,
                                                    height: 90,
                                                    borderRadius: 2,
                                                    objectFit: "cover",
                                                    border: "2px solid #eee",
                                                    boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
                                                }}
                                            />
                                        ))}
                                    </Box>

                                </CardContent>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            </Box>
        </>
    );
};

export default OfferBannerList;
